<template>
<div ref="EditPetBreed">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">批量修改宠物品种</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="petlists.length > 0 ? petlists.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回宠物管理</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box">
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">宠物品种</label>
                    <div class="TTL-select">
                    <el-select v-model="breedid" placeholder="请选择宠物类型" filterable clearable>
                    <el-option v-for="(item,index) in breedlist" :key="index" :label="item.breedname" :value="item.id">
                    <div class="TTL-select-infos">
                    <span>{{item.breedname}}</span>
                    </div>
                    </el-option>
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item class="top50">
                    <div class="TTL-pet-label-lists">
                        <div class="TTL-pet-label-lists-detail" v-for="(item,index) in petlists">
                            <el-image :src="item.thumb ? item.thumb : require('@/assets/icon/pet-gray.png')" fit="cover" class="TTL-image-box-middle"/>
                            <span class="TTL-pet-name">{{item.name}}</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            breedlist:[],
            breedid:'',
            petlists:[
                {id:1,name:'再下沙雕派-肌肉老六'},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetBreedInfos(); //获取宠物类型信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetPetInfos(data.ids); //获取待处理宠物
                }).catch(()=> {
                    
                });

            }else if(data.reload) {             //浏览器重新刷新时执行的操作
                this.ParseDataFromBrowser();    //从浏览器里解析数据到当前组件
            }else {
                this.GetPetInfos(data.ids);     //获取待处理宠物

            }
        },


        /** 提交数据 **/
        submitData() {
            if(this.petlists.length==0) {this.$notice({title:'消息提示',message:'请选择要批量处理的数据',type:'warning'});return false;}
            if(!this.breedid || this.breedid==0) {this.$notice({title:'消息提示',message:'请选择要修改的品种信息',type:'warning'});return false;}

            //获取待提交的宠物id信息
            var ids=this.GetSelectDataIds();
            var param={ids:ids.join(','),breedid:this.breedid};
            this.$loading.openloading(this.$refs.EditPetBreed); //加载等待动画
            INTERFACE_MODEL_PETS.UPDATE_PET_BREED_MORE(param).then((res) => {
                 this.$loading.closeloading(this.$refs.EditPetBreed);
                 if(res.status > 0) return false;
                
                 this.$notice({title:'消息提示',message:'数据处理成功',type:'success'});
                 this.ClearDataFromBrowser(); //清空当前浏览器保存的操作数据
                 this.GoBackPets(true); //跳转至宠物管理页
             });

        },


        /** 根据id获取宠物信息 **/
        GetPetInfos(ids) {
            this.$loading.openloading(this.$refs.EditPetBreed); //加载等待动画
            var petparam={ids:ids,p:1,rollpage:100000};

            INTERFACE_MODEL_PETS.GET_PET_INFO_LIST(petparam).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(this.$refs.EditPetBreed);
                 var pets=res.data.list;

                 //处理数据
                 this.petlists=[];
                 for(var i=0;i < pets.length;i++) 
                 this.petlists.push({id:pets[i].id,name:pets[i].name,thumb:pets[i].thumb});
                 this.breedid='';            //重置选中的品种信息
                 this.SaveDataToBrowser();   //将当前数据保存到浏览器里
            });
        },


        /** 获取宠物类型信息 **/
        GetBreedInfos() {
            INTERFACE_MODEL_PETS.GET_PET_BREEDS_ALL({}).then((res) => {
                 if(res.status > 0) return false;
                 this.breedlist=res.data;
             });
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.petlists.map((obj)=> obj.id);
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        ///////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////
        //底层操作
        
        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify({petlists:this.petlists,breedid:this.breedid});
            localStorage.setItem('EditPetBreedMoredata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('EditPetBreedMoredata');
            data ? data : data=[];

            if(!data || data=='' || data==[]) {
                this.petlists=[];
                this.breedid='';
            }else {
                this.petlists=data.petlists;
                this.breedid=data.breedid;
            }
        },

        /** 从浏览器中清空当前数据 **/
        ClearDataFromBrowser() {
            this.petlists=[];
            this.breedid='';
            localStorage.setItem('EditPetBreedMoredata','');
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'宠物管理',labelentry:'Pet',components:'Pet',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditPetBreedMore'; //跳转后要删除的组件
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-btn-option {display:inline-block;margin-right:20px;}
.TTL-pet-label-lists {display:inline-block;width:100%;}
.TTL-pet-name {font-size:13px;padding-left:20px;color:#666666;}
.TTL-pet-label-lists-detail {
    display:inline-flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    padding:20px 0;
    border-bottom:1px solid #F2F6FC;
}
.TTL-pet-label-lists-detail:last-child() {border-bottom: none};
</style>